// src/routes/PrivateRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

export default function PrivateRoute() {
  const location = useLocation();
  const auth = isAuthenticated();
  if (!auth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
